export const urlCoreBack = import.meta.env.VITE_CORE_BACK;
export const urlBucketBack = import.meta.env.VITE_BUCKET_BACK;
export const systemCode = import.meta.env.VITE_SYSTEM_CODE || "deposito";
export const systemName = import.meta.env.VITE_SYSTEM_NAME || "Sistema de Depósito";